import { useTranslation } from 'react-i18next';
import { useCommonSelector } from '@wajeez-web/stores/common';
import { InputLabel } from '@wajeez-web/components/ui';
import { PredefinedComponentFormType } from '../Types';
import {
  FieldValues,
  useController,
  UseControllerProps,
} from 'react-hook-form';
import Select from 'react-select';

export interface FormPredefinedComponentInputProps<
  TFormFields extends FieldValues
> extends UseControllerProps<TFormFields> {
  fieldType: PredefinedComponentFormType;
  disabled?: boolean;
}

const FormPredefinedComponentInput = <TFormFields extends FieldValues>({
  fieldType,
  disabled,
  ...props
}: FormPredefinedComponentInputProps<TFormFields>) => {
  const { field, fieldState } = useController({
    ...props,
    rules: {
      required: fieldType.required ? 'Required' : undefined,
      ...props.rules,
    },
  });

  const { dir } = useCommonSelector((state) => state.common.settings);

  const { t } = useTranslation();

  const isError = fieldState.error && fieldState.isTouched;

  const items =
    fieldType.fieldOptions.allowedPredefinedComponents?.map((item) => ({
      label: item,
      value: item,
    })) || [];
  return (
    <>
      {fieldType.label && (
        <InputLabel
          text={
            t(
              `inputs.labels.${fieldType.label}`,
              fieldType.label.toString() || ''
            ) as string
          }
          name={field.name}
          required={fieldType.required}
        />
      )}
      <Select
        isMulti={true}
        placeholder={fieldType.placeHolder}
        isDisabled={disabled}
        className={isError ? 'border-red-500' : ''}
        options={items}
        value={items.find((s) => s.value === field.value)}
        onChange={(value) => {
          if (Array.isArray(value)) {
            field.onChange(value.map((v) => v.value));
          } else {
            field.onChange((value as any)?.value);
          }
          field.onBlur();
        }}
      />
    </>
  );
};

export default FormPredefinedComponentInput;
